import React, { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { motion } from "framer-motion";
import { FiArrowRight } from "react-icons/fi";
import { MdClose } from "react-icons/md";
import { useLanguage } from "../i18n";
import aasImage from "../Assets/products/Analytical Instruments/Atomic Absorption Spectrophotometer (AAS).jpg";
import fluorescenceSpectrophotometerImage from "../Assets/products/Analytical Instruments/Fluorescence Spectrophotometer.jpg";
import ftirSpectrometerImage from "../Assets/products/Analytical Instruments/FTIR Spectrometer.jpg";
import gasChromatographImage from "../Assets/products/Analytical Instruments/Gas Chromatograph (GC).jpg";
import gcMsImage from "../Assets/products/Analytical Instruments/GC-MS.jpg";
import hplcSystemsImage from "../Assets/products/Analytical Instruments/HPLC Systems.jpg";
import icpOesIcpMsImage from "../Assets/products/Analytical Instruments/ICP-OES and ICP-MS.jpg";
import ionChromatographyImage from "../Assets/products/Analytical Instruments/Ion Chromatography.jpg";
import lcMsImage from "../Assets/products/Analytical Instruments/LC-MS and LC-MS.jpg";
import nirAnalyzerImage from "../Assets/products/Analytical Instruments/NIR Analyzer.jpg";
import particleSizeAnalyzerImage from "../Assets/products/Analytical Instruments/Particle Size Analyzer.jpg";
import portableNmrImage from "../Assets/products/Analytical Instruments/Portable NMR.jpg";
import potentiometricTitratorsImage from "../Assets/products/Analytical Instruments/Potentiometric Titrators.jpg";
import uvVisSpectrophotometerImage from "../Assets/products/Analytical Instruments/UV-Vis Spectrophotometer.jpg";
import xRayDiffractometerImage from "../Assets/products/Analytical Instruments/X-Ray Diffractometer (XRD).jpg";
import xRayFluorescenceImage from "../Assets/products/Analytical Instruments/X-Ray Fluorescence Analyzer.jpg";
import chromoImage from "../Assets/products/Chromatography Columns/ChromoColoumn1.jpg";
import chromoGcImage from "../Assets/products/Chromatography Columns/ChromoColoumn2.jpg";
import chromoUvImage from "../Assets/products/Chromatography Columns/ChromoColoumn3.jpg";
import hplcColumnImage from "../Assets/products/Chromatography Columns/HPLColoumn.jpg";
import balancesImage from "../Assets/products/General Lab Equipment/Balances.jpg";
import centrifugesImage from "../Assets/products/General Lab Equipment/Centrifuges.jpg";
import digitalDryBathsImage from "../Assets/products/General Lab Equipment/Digital Dry Baths.jpg";
import hotAirOvensImage from "../Assets/products/General Lab Equipment/Hot Air Ovens.jpg";
import hotplatesMagneticStirrersImage from "../Assets/products/General Lab Equipment/Hotplates and Magnetic Stirrers.jpg";
import incubatorsImage from "../Assets/products/General Lab Equipment/Incubators.jpg";
import liquidHandlingProductsImage from "../Assets/products/General Lab Equipment/Liquid Handling Products.jpg";
import phMetersImage from "../Assets/products/General Lab Equipment/pH Meters.jpg";
import rotaryEvaporatorsImage from "../Assets/products/General Lab Equipment/Rotary Evaporators.jpg";
import shakersThermalMixersImage from "../Assets/products/General Lab Equipment/Shakers and Thermal Mixers.jpg";
import vortexMixersImage from "../Assets/products/General Lab Equipment/Vortex Mixers.jpg";
import waterBathsImage from "../Assets/products/General Lab Equipment/Water Baths.jpg";
import autoclavesStirrersImage from "../Assets/products/Life Sciences Equipment/Autoclaves and Stirrers.jpg";
import automaticColonyCounterImage from "../Assets/products/Life Sciences Equipment/Automatic Colony Counter.jpg";
import chemiluminescenceImagingSystemsImage from "../Assets/products/Life Sciences Equipment/Chemiluminescence Imaging Systems.jpg";
import co2IncubatorImage from "../Assets/products/Life Sciences Equipment/CO₂ Incubator.jpg";
import deepFreezersImage from "../Assets/products/Life Sciences Equipment/Deepfreezers.jpg";
import fermentersImage from "../Assets/products/Life Sciences Equipment/Fermenters.jpg";
import gelDocumentationSystemsImage from "../Assets/products/Life Sciences Equipment/Gel Documentation Systems.jpg";
import liveCellImagingSystemsImage from "../Assets/products/Life Sciences Equipment/Live Cell Imaging Systems.jpg";
import nucleicAcidExtractionKitsImage from "../Assets/products/Life Sciences Equipment/Nucleic Acid Extraction Kits.jpg";
import pcrThermalCyclerImage from "../Assets/products/Life Sciences Equipment/PCR Thermal Cycler.jpg";
import sprayDryersImage from "../Assets/products/Life Sciences Equipment/Spray Dryers.jpg";
import uvLightBoxImage from "../Assets/products/Life Sciences Equipment/UV Light Box.jpg";
import biologicalMicroscopeImage from "../Assets/products/Microscopy/Biologicalmicroscope.jpg";
import digitalMicroscopeImage from "../Assets/products/Microscopy/Digital Microscope.jpg";
import educationalMicroscopesImage from "../Assets/products/Microscopy/Educational Microscopes.jpg";
import industrialMicroscopesImage from "../Assets/products/Microscopy/Industrial Microscopes.jpg";
import scanningElectronMicroscopesImage from "../Assets/products/Microscopy/Scanning Electron Microscopes (SEM).jpg";
import semSamplePreparationImage from "../Assets/products/Microscopy/SEM Sample Preparation Systems.jpg";
import spinCoatersImage from "../Assets/products/Microscopy/Spin Coaters.jpg";
import transmissionElectronMicroscopesImage from "../Assets/products/Microscopy/Transmission Electron Microscopes.jpg";
import shakerMixer3dImage from "../Assets/products/Sample Preparation Equipment/3D Shaker Mixer.jpg";
import beadMillHomogenizerImage from "../Assets/products/Sample Preparation Equipment/Bead Mill Homogenizer.jpg";
import gasGeneratorsImage from "../Assets/products/Sample Preparation Equipment/Gas Generators.jpg";
import highPressureHomogenizersImage from "../Assets/products/Sample Preparation Equipment/High Pressure Homogenizers.jpg";
import knifeCentrifugalMillsImage from "../Assets/products/Sample Preparation Equipment/Knife and Centrifugal Mills.jpg";
import microwaveDigestionSystemImage from "../Assets/products/Sample Preparation Equipment/Microwave Digestion System.jpg";
import mortarBallMillsImage from "../Assets/products/Sample Preparation Equipment/Mortar and Ball Mills.jpg";
import rotarySampleDividerImage from "../Assets/products/Sample Preparation Equipment/Rotary Sample Divider.jpg";
import rotorStatorHomogenizerImage from "../Assets/products/Sample Preparation Equipment/Rotor Stator Homogenizer.jpg";
import sieveShakerImage from "../Assets/products/Sample Preparation Equipment/Sieve Shaker.jpg";
import smartGraphiteDigesterImage from "../Assets/products/Sample Preparation Equipment/Smart Graphite Digester.jpg";
import vacuumOvenImage from "../Assets/products/Sample Preparation Equipment/Vacuum Oven.jpg";
import vibratoryDiscMillImage from "../Assets/products/Sample Preparation Equipment/Vibratory Disc Mill.jpg";

const productImages = {
  analytical: uvVisSpectrophotometerImage,
  lifeScience: gelDocumentationSystemsImage,
  generalLab: balancesImage,
  microscopy: "/product-images/compound-microscope.jpg",
  samplePreparation: rotorStatorHomogenizerImage,
  chromatography: chromoImage,
};

const productItem = (name, image) => ({
  name,
  image,
  toString: () => name,
});

const categories = [
  {
    name: "Analytical Instruments",
    image: productImages.analytical,
    items: [
      productItem("UV-Vis Spectrophotometer", uvVisSpectrophotometerImage),
      productItem("Atomic Absorption Spectrophotometer (AAS)", aasImage),
      productItem(
        "Fluorescence Spectrophotometer",
        fluorescenceSpectrophotometerImage
      ),
      productItem("Ion Chromatography", ionChromatographyImage),
      productItem("Particle Size Analyzer", particleSizeAnalyzerImage),
      productItem("NIR Analyzer", nirAnalyzerImage),
      productItem("Gas Chromatograph (GC)", gasChromatographImage),
      productItem("GC-MS", gcMsImage),
      productItem("HPLC Systems", hplcSystemsImage),
      productItem("LC-MS and LC-MS/MS", lcMsImage),
      productItem("X-Ray Fluorescence Analyzer (XRF)", xRayFluorescenceImage),
      productItem("X-Ray Diffractometer (XRD)", xRayDiffractometerImage),
      productItem("FTIR Spectrometer", ftirSpectrometerImage),
      productItem("ICP-OES and ICP-MS", icpOesIcpMsImage),
      productItem("Portable NMR", portableNmrImage),
      productItem("Potentiometric Titrators", potentiometricTitratorsImage),
    ],
  },
  {
    name: "Life Sciences Equipment",
    image: productImages.lifeScience,
    items: [
      productItem("Gel Documentation Systems", gelDocumentationSystemsImage),
      productItem(
        "Chemiluminescence Imaging Systems",
        chemiluminescenceImagingSystemsImage
      ),
      productItem("UV Light Box", uvLightBoxImage),
      productItem("PCR Thermal Cycler", pcrThermalCyclerImage),
      productItem("CO2 Incubator", co2IncubatorImage),
      productItem("Live Cell Imaging Systems", liveCellImagingSystemsImage),
      productItem("Nucleic Acid Extraction Kits", nucleicAcidExtractionKitsImage),
      productItem("Fermenters", fermentersImage),
      productItem("Autoclaves and Stirrers", autoclavesStirrersImage),
      productItem("Automatic Colony Counter", automaticColonyCounterImage),
      productItem("Spray Dryers", sprayDryersImage),
      productItem("Deep Freezers", deepFreezersImage),
    ],
  },
  {
    name: "General Lab Equipment",
    image: productImages.generalLab,
    items: [
      productItem("Balances", balancesImage),
      productItem("Centrifuges", centrifugesImage),
      productItem("Digital Dry Baths", digitalDryBathsImage),
      productItem("Hotplates and Magnetic Stirrers", hotplatesMagneticStirrersImage),
      productItem("Liquid Handling Products", liquidHandlingProductsImage),
      productItem("Shakers and Thermal Mixers", shakersThermalMixersImage),
      productItem("Vortex Mixers", vortexMixersImage),
      productItem("Rotary Evaporators", rotaryEvaporatorsImage),
      productItem("pH Meters", phMetersImage),
      productItem("Hot Air Ovens", hotAirOvensImage),
      productItem("Water Baths", waterBathsImage),
      productItem("Incubators", incubatorsImage),
    ],
  },
  {
    name: "Microscopy",
    image: productImages.microscopy,
    items: [
      productItem(
        "Transmission Electron Microscopes (TEM)",
        transmissionElectronMicroscopesImage
      ),
      productItem("Educational Microscopes", educationalMicroscopesImage),
      productItem("Biological Microscopes", biologicalMicroscopeImage),
      productItem("Digital Microscopes", digitalMicroscopeImage),
      productItem("Industrial Microscopes", industrialMicroscopesImage),
      productItem(
        "Scanning Electron Microscopes (SEM)",
        scanningElectronMicroscopesImage
      ),
      productItem("SEM Sample Preparation Systems", semSamplePreparationImage),
      productItem("Spin Coaters", spinCoatersImage),
    ],
  },
  {
    name: "Sample Preparation Equipment",
    image: productImages.samplePreparation,
    items: [
      productItem("Rotor Stator Homogenizer", rotorStatorHomogenizerImage),
      productItem("Bead Mill Homogenizer", beadMillHomogenizerImage),
      productItem("High Pressure Homogenizers", highPressureHomogenizersImage),
      productItem("Microwave Digestion System", microwaveDigestionSystemImage),
      productItem("Gas Generators", gasGeneratorsImage),
      productItem("Vacuum Oven", vacuumOvenImage),
      productItem("Mortar and Ball Mills", mortarBallMillsImage),
      productItem("Sieve Shaker", sieveShakerImage),
      productItem("Knife and Centrifugal Mills", knifeCentrifugalMillsImage),
      productItem("Vibratory Disc Mill", vibratoryDiscMillImage),
      productItem("3D Shaker Mixer", shakerMixer3dImage),
      productItem("Rotary Sample Divider", rotarySampleDividerImage),
      productItem("Smart Graphite Digester", smartGraphiteDigesterImage),
    ],
  },
  {
    name: "Chromatography Columns",
    image: productImages.chromatography,
    items: [
      productItem("HPLC Columns", hplcColumnImage),
      productItem(
        "Lamps for UV-Vis Spectrophotometers and HPLC Detectors",
        chromoUvImage
      ),
      productItem("GC and GC-MS Columns", chromoGcImage),
    ],
  },
];

const getProductName = (item) => (typeof item === "string" ? item : item.name);
const getProductImage = (item, fallbackImage) =>
  typeof item === "string" ? fallbackImage : item.image || fallbackImage;

function ProductCard({ category }) {
  const [open, setOpen] = useState(false);
  const { t } = useLanguage();

  return (
    <>
      <motion.article
        className="product-card"
        initial={{ y: 25, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        viewport={{ once: true }}
      >
        {category.image && (
          <img src={category.image} alt={category.name} className="product-card-image" />
        )}
        <div className="product-card-content">
          <span className="product-count">{category.items.length} {t.solutions}</span>
          <h3>{category.name}</h3>
          <p>{category.items.slice(0, 3).join(" • ")}</p>
          <button
            type="button"
            className="secondary-button"
            onClick={() => setOpen(true)}
          >
            {t.viewProducts} <FiArrowRight />
          </button>
        </div>
      </motion.article>

      <Dialog
        fullWidth
        maxWidth="md"
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby={`${category.name.replace(/\s/g, "-")}-title`}
      >
        <DialogTitle id={`${category.name.replace(/\s/g, "-")}-title`}>
          {category.name}
          <IconButton
            aria-label={t.close}
            onClick={() => setOpen(false)}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <MdClose />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <ul className="product-dialog-list">
            {category.items.map((item) => (
              <li key={getProductName(item)} className="product-dialog-item">
                <img src={getProductImage(item, category.image)} alt="" loading="lazy" />
                <span>{getProductName(item)}</span>
              </li>
            ))}
          </ul>
          <p className="product-dialog-note">
            {t.availability}
          </p>
        </DialogContent>
        <DialogActions>
          <Button href="#contact" onClick={() => setOpen(false)}>
            {t.quote}
          </Button>
          <Button onClick={() => setOpen(false)}>{t.close}</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default function Products() {
  const { t } = useLanguage();
  return (
    <section id="products" className="products-section">
      <div className="work-section-top">
        <h2 className="primary-subheading" data-outline={t.products}>
          {t.products}
        </h2>
        <h3 className="section-title">{t.productsTitle}</h3>
        <p className="section-intro">
          {t.productsIntro}
        </p>
      </div>
      <div className="products-grid">
        {categories.map((category) => (
          <ProductCard category={category} key={category.name} />
        ))}
      </div>
    </section>
  );
}
